<template>
  <el-dialog
    @click.native.stop
    custom-class="voice-dialog"
    :visible.sync="visible"
    width="804px"
    top="145px"
    :close-on-click-modal="false"
    :append-to-body="true"
    :show-close="false"
  >
    <div slot="title" class="title">多人配音音色选择</div>
    <div class="voice-form">
      <div class="voice-list">
        <div 
          v-for="voice in voiceList" 
          :key="voice.speaker_id"
          class="voice-item"
          :class="{ active: form.voice === voice.speaker_id }"
          @click="selectVoice(voice)"
        >
          <div class="voice-item-name">{{ voice.name }}</div>
        </div>
      </div>
    </div>
    <span slot="footer" class="btn-container">
      <el-button class="btn btn-primary" type="primary" @click="handleConfirm">确定</el-button>
      <el-button class="btn" @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Dialog, Button } from 'element-ui'

export default {
  components: {
    'el-dialog': Dialog,
    'el-button': Button
  },

  props: {
    voiceList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      visible: false,
      form: {
        voice: ''
      },
      savedRange: null
    }
  },

  computed: {
    selectedText() {
      return this.savedRange ? this.savedRange.toString() : ''
    }
  },

  methods: {
    show(range, voiceList) {
      this.visible = true
      this.savedRange = range
      this.voiceList = voiceList
      this.form.voice = ''
    },

    selectVoice(voice) {
      this.form.voice = voice.speaker_id
    },

    handleConfirm() {
      if (!this.form.voice) {
        this.$message.warning('请选择配音音色')
        return
      }

      const selectedVoice = this.voiceList.find(v => v.speaker_id === this.form.voice)
      
      this.$emit('confirm', {
        attrs: {
          name: this.form.voice,
          'display-type': `${selectedVoice.name}`
        },
        range: this.savedRange
      })
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.voice-form {
  overflow-y: auto;
  padding-right: 20px;

  // 滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(185, 195, 195, 0.5);
    border-radius: 3px;
  }

  .voice-list {
    max-height: 300px;
    // margin: 16px 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 10px;

    .voice-item {
      display: flex;
      align-items: center;
      padding: 20px;
      cursor: pointer;
      border-radius: 12px;
      background: #F7F7F9;
      border: 1px solid #F7F7F9;

      &:hover {
        background: rgba(65,180,140,0.1);
      }

      &.active {
        background: rgba(65,180,140,0.1);
        border: 1px solid #41B48C;
      }

      .voice-item-name {
        font-family: PingFang-SC, PingFang-SC;
        font-weight: bold;
        font-size: 16px;
        color: #323B4B;
      }
    }
  }
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 2px;

  .btn {
    width: 65px;
    height: 32px;
    background: #B9C3C3;
    border-radius: 4px;
    font-family: PingFang-SC, PingFang-SC;
    font-size: 14px;
    color: #FFFFFF;
    padding: 0;
    border: none;
    outline: none;
  }

  .btn-primary {
    background: #41B48C;
  }
}
</style>
<style lang="less">
.voice-dialog {
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15) !important;
  border-radius: 4px !important;

  .el-dialog__header {
    padding: 32px 0 20px 32px;
  }

  .title {
    font-family: PingFang-SC, PingFang-SC;
    font-weight: bold;
    font-size: 16px;
    color: rgba(50,59,75,0.85);
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }

  .el-dialog__body {
    padding: 0 6px 0 32px;
  }

  .el-dialog__footer {
    padding: 20px 32px 24px 32px;
  }
}
</style>